import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
    selector: 'app-documentacion-arco',
    imports: [],
    templateUrl: './documentacion-arco.component.html',
    styleUrl: './documentacion-arco.component.scss'
})
export class DocumentacionArcoComponent implements OnInit {
    urlSafe!: SafeResourceUrl;

    constructor(private sanitizer: DomSanitizer) {}

    ngOnInit() {
        this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl('https://docs.jaca.com.py/');
    }
}
